module.exports = __webpack_public_path__ + "img/43.315cc4d2.png";